import React, { useState } from "react";
import "./Faqs.css";
import BlogImg from "../assets/images/Blog.png";

const faqData = [
  {
    question: "What is PlotsVerified?",
    answer:
      "PlotsVerified is a platform that verifies land plots through legal due diligence, site inspections, and official document checks. Our team includes experienced legal consultants and former Mandal Revenue Officers (MROs) who ensure that the plot you're buying is free of disputes, encroachments, or fraudulent ownership. We also provide one year of free legal support post-purchase."
  },
  {
    question: "Does PlotsVerified verify individual plots or assist individual buyers?",
    answer:
      "No. We do not offer plot verification services for individual buyers. Our due diligence process is reserved for land ventures and large parcels submitted by developers, aggregators, or land-owning companies. Buyers benefit by choosing from only pre-cleared and verified listings on our platform."
  },
  {
    question: "Who verifies the land ventures listed on your platform?",
    answer:
      "Our verification is handled by experienced legal consultants with expertise in real estate and land laws, and former Mandal Revenue Officers (MROs) who bring insider knowledge of land records, mutations, and regulatory compliance."
  },
  {
    question: "What kind of documents are verified before a venture is listed?",
    answer:
      "We verify title deed and ownership lineage, encumbrance certificate, revenue and registration records, tax clearances, layout approvals (DTCP, HMDA, etc.), and zoning compliance. Only ventures passing all checks are published."
  },
  {
    question: "What makes PlotsVerified different from real estate listing sites?",
    answer:
      "Typical sites display unverified listings. At PlotsVerified, every venture is verified before listing, with no middlemen, full documentation, and one-year free legal support."
  },
  {
    question: "What is included in the 1-year free legal support?",
    answer:
      "If any litigation or ownership issues arise during the first year after purchase, our advocates will represent you in court at no extra cost."
  },
  {
    question: "Can I list my land or venture on PlotsVerified?",
    answer:
      "Yes—if you’re a company, developer, or land aggregator with a large parcel of land. Individual landowners or agents are not eligible at this time."
  },
  {
    question: "What is the Venture AI feature?",
    answer:
      "Our AI tool provides real-time insights into area development, government zoning updates, and forecasted land value appreciation."
  },
  {
    question: "Where is PlotsVerified currently active?",
    answer:
      "We are active in select cities and emerging corridors in India. Explore ventures in our Verified Listings section."
  },
  {
    question: "How do I know if a listing is really verified?",
    answer:
      "Each listing has a verified badge, a verification summary, and key legal documents accessible after inquiry."
  },
  {
    question: "Is there any cost for buyers to use PlotsVerified?",
    answer:
      "Browsing is free. You pay only when purchasing a plot from a verified venture. Legal support is free for the first year."
  }
];

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* Banner Section */}
      <div className="blog-container home-container1">
        <div
          className="banner-section"
          style={{ backgroundImage: `url(${BlogImg})` }}
        >
          <div className="banner-overlay"></div>
          <div className="banner-content">
            <h1>FAQs</h1>
            <p className="breadcrumb-text">
              <span>Home</span> <span className="arrow">→</span> <span>FAQs</span>
            </p>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faqs-container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              key={index}
            >
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className="faq-icon">{activeIndex === index ? "−" : "+"}</span>
              </div>
              <div
                className="faq-answer"
                style={{
                  maxHeight: activeIndex === index ? "500px" : "0px",
                  padding: activeIndex === index ? "10px 20px" : "0"
                }}
              >
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FAQs;
